import { BasePostProvider } from "@tendercuts/http";
import { EndPoint } from "../base";
import { GenericServerResponse } from "@tendercuts/models";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginServices } from "../login/services";

@Injectable({ providedIn: "root" })
export class CarryBagService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get isCachable() {
    return false;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return GenericServerResponse;
  }

  get endpoint() {
    return this.endpointService.carryBagRewards();
  }

  getParams(searchValue: string) {
    const params = {
      order_id: searchValue,
    };
    return params;
  }
}
